module.exports = __webpack_public_path__ + "img/book.4ee96a1a.png";